import { cn } from '../../lib/cn';
import type { CommandCenterKPI } from '../../unifiedcommerce/framework';

type Props = { kpis?: CommandCenterKPI[] };

export function UnifiedCommerceCommandCenterPanel({ kpis = [] }: Props) {
  return (
    <div className="grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
      {kpis.map((k) => (
        <div key={k.label} className="rounded-lg border border-slate-200 bg-white p-3 dark:border-slate-700 dark:bg-slate-900">
          <p className="text-xs text-slate-500">{k.label}</p>
          <p className="mt-1 text-lg font-semibold text-slate-900 dark:text-slate-100">{k.value}</p>
          <p className={cn('mt-0.5 text-xs font-medium', k.positive ? 'text-success-600' : 'text-error-600')}>
            {k.change}
          </p>
        </div>
      ))}
    </div>
  );
}
